export function openSupport(): void {
  const intercom = window.Intercom;
  if (typeof intercom !== 'function') return;

  intercom('show');
  intercom('showSpace', 'help');
}
